/**
 * Configuration des types pour le composant barre de recherche
 * Ce fichier peut être facilement modifié pour ajouter, supprimer ou mettre à jour les options de types
 */
export const defaultTypes = [
  {
    code: 'all',
    label: 'Toutes les catégories',
    name: 'Tous les types',
    description: 'Rechercher dans tous les types de contenu',
    default: true,
    isAllTypes: true
  },
  {
    code: 'termino',
    label: 'Terminologies',
    name: 'Terminologies',
    description: 'Rechercher uniquement dans les terminologies',
    default: false
  },
  {
    code: 'concept',
    label: 'Concepts',
    name: 'Concepts',
    description: 'Rechercher uniquement dans les concepts',
    default: false
  },
  {
    code: 'alignement',
    label: 'Alignements',
    name: 'Alignements',
    description: 'Rechercher uniquement dans les alignements',
    default: false
  }

];

/**
 * Fonction utilitaire pour obtenir le type par défaut d'un tableau de types
 * @param {Array} types - Tableau d'objets type
 * @returns {Object|null} - Objet type par défaut ou premier type si aucun par défaut trouvé
 */
export function getDefaultType(types) {
  const defaultType = types.find(type => type.default === true);
  return defaultType || types[0] || null;
}


/**
 * Fonction utilitaire pour vérifier si un code correspond à "tous les types"
 * @param {string} code - Code du type à vérifier
 * @returns {boolean} - Vrai si c'est le code "tous les types"
 */
export function isAllTypesCode(code) {
  return code === 'all' || defaultTypes.some(type => 
    type.code === code && type.isAllTypes === true
  );
}

/**
 * Fonction utilitaire pour obtenir tous les types disponibles (exclut "all")
 * @param {Array} types - Tableau d'objets type (optionnel, utilise defaultTypes par défaut)
 * @returns {Array} - Tableau des codes de types disponibles
 */
export function getAvailableTypeCodes(types = defaultTypes) {
  return types
    .filter(type => !type.isAllTypes)
    .map(type => type.code);
}

/**
 * Fonction utilitaire pour obtenir un type par son code
 * @param {string} code - Code du type recherché
 * @param {Array} types - Tableau d'objets type (optionnel, utilise defaultTypes par défaut)
 * @returns {Object|null} - Objet type trouvé ou null
 */
export function getTypeByCode(code, types = defaultTypes) {
  return types.find(type => type.code === code) || null;
}

/**
 * Fonction utilitaire pour formater les types pour l'affichage
 * @param {Array} typeCodes - Tableau des codes de types sélectionnés
 * @param {Array} types - Tableau d'objets type (optionnel, utilise defaultTypes par défaut)
 * @returns {string} - Chaîne formatée des types sélectionnés
 */
export function formatSelectedTypes(typeCodes, types = defaultTypes) {
  // Vérifie si le paramètre est un tableau valide et non vide
  if (!Array.isArray(typeCodes) || typeCodes.length === 0) {
    return 'Aucun type sélectionné';
  }

  // Si "all" est présent dans la sélection
  if (typeCodes.includes('all')) {
    return 'Tous les types';
  }

  // Filtre les codes valides en supprimant les codes inexistants
  const validTypeCodes = typeCodes
    .map(code => getTypeByCode(code, types))
    .filter(type => type !== null)
    .map(type => type.code);

  // Récupère la liste de tous les types disponibles (exclut "all")
  const availableCodes = getAvailableTypeCodes(types);
  
  // Vérifie si tous les codes disponibles sont sélectionnés
  // Cette vérification ignore les codes invalides
  if (validTypeCodes.length === availableCodes.length && 
      availableCodes.every(code => validTypeCodes.includes(code))) {
    return 'Tous les types';
  }

  // Formate les labels des types valides pour affichage
  const typeNames = typeCodes
    .map(code => getTypeByCode(code, types))
    .filter(type => type !== null)
    .map(type => type.label);

  return typeNames.join(', ');
}
